module.exports = __webpack_public_path__ + "img/register.915cde42.svg";